export default __webpack_public_path__ + "static/media/recipe_bg.dd04813b.png";